import { render, staticRenderFns } from "./realignment-table.vue?vue&type=template&id=7a9acfe4&"
import script from "./realignment-table.vue?vue&type=script&lang=js&"
export * from "./realignment-table.vue?vue&type=script&lang=js&"
import style0 from "./realignment-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports